import React from "react";

import {
  Grid,
  GridItem
} from "@patternfly/react-core";

import AnnouncementsCarousel from "../../announcements/components/AnnouncementsCarousel";
import SocialCarousel from "../../social/components/SocialCarousel";

import AnnouncementHeroSkeleton from "../../announcements/components/AnnouncementHeroSkeleton";
import SocialHeroSkeleton from "../../social/components/SocialHeroSkeleton";

import "./HomeHeroes.css";

const HomeHeroes = ({
  announcements,
  socialPosts,
  isAnnouncementsLoading,
  isSocialLoading,
  socialError
}) => {
  return (
    <Grid
      hasGutter
      className="school-home-heroes"
    >
      <GridItem
        span={12}
        xl={6}
        className="school-home-heroes__item"
      >
        {isAnnouncementsLoading ? (
          <AnnouncementHeroSkeleton />
        ) : (
          <AnnouncementsCarousel
            announcements={announcements}
            useGradient={false}
            gradientVariant="blue"
          />
        )}
      </GridItem>

      <GridItem
        span={12}
        xl={6}
        className="school-home-heroes__item"
      >
        {isSocialLoading ? (
          <SocialHeroSkeleton />
        ) : (
          <SocialCarousel
            posts={socialPosts}
            useGradient={true}
            gradientVariant="blue"
          />
        )}
      </GridItem>
    </Grid>
  );
};

export default HomeHeroes;